import format from 'date-fns/format';
import de from 'date-fns/locale/de';

const locales = { de };

export default (date, formatStr, options) =>
  formatStr ? format(date, formatStr, { ...options, locale: locales.de }) : date;
